export const ParameterCodeDataPolicy = ({

    DEFAULT_TEU_FACTOR_CODE: "DEFAULT_TEU_FACTOR",
    MARSHALLING_TYPE: "MARSHALLING_TYPE",
    CNTR_SIZE: "CNTR_SIZE",
    CNTR_TYPE: "CNTR_TYPE",
    PRINTER: "PRINTER",
    CARGO_TYPE: "CARGO_TYPE",
    CARGO_CODE: "CARGO_CODE",
    ACCOUNT_TERMINAL_REASON_CODE: "ACCT_TML_REASON_CODE",
    TAX_CODE: "AR_TAX_CODE",
    GL_DEFAULT: "AR_DEFAULT_SETTING",
    GL_COUNTRY: "AR_COUNTRY",
    RA_TYPE: "RA_TYPE",
    REQ_NATURE: "REQ_NATURE",
    ARTICLE_STMT_CODE: "ARTICLE_STMT_CODE",
    REQ_MGR_IN_CHARGE: "REQ_MGR_IN_CHARGE",
    REQ_ACCT_MGR: "REQ_ACCT_MGR",
    REQ_FIN: "REQ_FIN",
    REQ_COM: "REQ_COM",
    REQ_MD: "REQ_MD",
    REQ_GMD: "REQ_GMD",
    LOCAL_CURRENCY: "LOCAL_CURRENCY",
    POOL_TYPE: "POOL_TYPE",
    SHIPMENT_TYPE: "SHIPMENT_TYPE",
    FSP_COUNTING_FROM: "FSP_COUNTING_FROM",
    FSP_COUNTING_TO: "FSP_COUNTING_TO",
    FSP_COUNTING_DIRECTION: "FSP_COUNTING_DIRECTION",
    UOM: "UOM",
    DELAY_REASON_CODE: "DELAY_REASON_CODE",
    MOVEMENT_IND: "MOVEMENT_IND",
    GL_CUTOFF_DATE: "GL_CUTOFF_DATE",
    INV_CUTOFF_DATE: "INV_CUTOFF_DATE",
    HALF_DAY_CUTOFF_TIME: "HALF_DAY_CUTOFF_TIME",
    DOC_BILL_MSG: "DOC_BILL_MSG",
    DOC_PORT_CODE: "DOC_PORT_CODE",
    DOC_CN_BILL_MSG: "DOC_CN_BILL_MSG",
    DOC_ABN_CODE: "DOC_ABN_CODE",
    SP_HANDLING_CODE: "SP_HANDLING_CODE",
    LOCATION_TYPE: "LOCATION_TYPE",
    GL_CUTOFF_DAYS_AHEAD_MONTHEND: "GL_CUTOFF_DAYS_AHEAD_MONTHEND",
    GL_CUTOFF_SETTING: "GL_CUTOFF_SETTING",
    RAILWAY_SETTING: "RAILWAY_SETTING",
    KM_LESS_THAN_TO_CHARGE_PER_CNTR: "KM_LESS_THAN_TO_CHARGE_PER_CNTR",
    HANDLE_SHORTSEA_AS: "HANDLE_SHORTSEA_AS",
    SPECIAL_AREAS_TO_CHARGE_PER_CNTR: "SPECIAL_AREAS_TO_CHARGE_PER_CNTR",
    FORWARDER_REFERENCE: "FORWARDER_REFERENCE",
    EQUIPMENT_CODE: "EQUIPMENT_CODE",
    STORAGE_TAX_TIER_GROUP: "STORAGE_TAX_TIER_GROUP",
    REGION: "REGION",
    DOC_SIGNATURE_PRIORITY: "DOC_SIGNATURE_PRIORITY",
    BILLING_CYCLE: "BILLING_CYCLE",
    DAMAGE_TYPE: "DAMAGE_TYPE",
    SERVICE_ORDER_CODE: "SERVICE_ORDER_CODE",
    DEFAULT_INTERCOMPANY_CODE: "DEFAULT_INTERCOMPANY_CODE",
    DEFAULT_FSP_COMPANY: "DEFAULT_FSP_COMPANY",
    DEFAULT_OPERATING_TML: "DEFAULT_OPERATING_TML",
    HANDLING_CHARGE: "HANDLING_CHARGE",
    DEPOSIT_BANK_CODE: "DEPOSIT_BANK_CODE",
    REFUND_REJECT_REASON_CODE: "REFUND_REJECT_REASON_CODE",
    LET_PASS_AC_THRESHOLD: "LET_PASS_AC_THRESHOLD",
    GATE_PASS_GRACE_HOUR: "GATE_PASS_GRACE_HOUR",
    CREDIT_NOTE_NATURE: "CREDIT_NOTE_NATURE",
    ADHOC_HOLD_REASON: "ADHOC_HOLD_REASON",
    BILLING_TYPE_INBOUND_NON_CY: "BILLING_TYPE_INBOUND_NON_CY",
    BILLING_TYPE_OUTBOUND_NON_CY: "BILLING_TYPE_OUTBOUND_NON_CY",
    LIFT_ON_OFF_IND: "LIFT_ON_OFF_IND",
    MOVEMENT_TYPE: "MOVEMENT_TYPE",
    WAIVER_REASON_CODE: "WAIVER_REASON_CODE",
    WAIVER_REJECT_REASON_CODE: "WAIVER_REJECT_REASON_CODE",
    DOCUMENT_CHARGE_RATE: "DOCUMENT_CHARGE_RATE",
    CC_WHARF_SUB_CHRGE_TYPE: "CC_WHARF_SUB_CHRGE_TYPE",
    SL_WHARF_SUB_CHRGE_TYPE: "SL_WHARF_SUB_CHRGE_TYPE",
    CC_WHARF_SUB_CHARGE_TYPE: "CC_WHARF_SUB_CHARGE_TYPE",
    SL_WHARF_SUB_CHARGE_TYPE: "SL_WHARF_SUB_CHARGE_TYPE",
    DEFAULT_LOC_FOR_DOC_SOFTCOPY: "DEFAULT_LOC_FOR_DOC_SOFTCOPY",
    DEFAULT_COUNTRY: "DEFAULT_COUNTRY",
    DEFAULT_PRINTER_DOC_PREV: "DEFAULT_PRINTER_DOC_PREV",
    REFUND_THRESHOLD_AMT: "REFUND_THRESHOLD_AMT",
    REQ_APPROVAL_LIMIT: "REQ_APPROVAL_LIMIT",
    HEAD_OF_BU: "HEAD_OF_BU",
    DM_DIRECTOR: "DM_DIRECTOR",
    HEAD_OF_BU_APPROVAL_LIST: "HEAD_OF_BU_APPROVAL_LIST",
    DM_DIRECTOR_APPROVAL_LIST: "DM_DIRECTOR_APPROVAL_LIST",
    MGR_IC: "MGR_IC",
    MGR_AC: "MGR_AC",
    FIN: "FIN",
    COM: "COM",
    MD: "MD",
    DOC_BANK_DETAILS: "DOC_BANK_DETAILS",
    DOC_ACCOUNT_NO: "DOC_ACCOUNT_NO",
    DOC_SORT_CODE: "DOC_SORT_CODE",
    DOC_IBAN_NO: "DOC_IBAN_NO",
    DOC_SWIFT_CODE: "DOC_SWIFT_CODE",
    DOC_TAX_STATEMENT: "DOC_TAX_STATEMENT",
    FISCAL_PRINTER: "FISCAL_PRINTER",
    DOC_MSG: "DOC_MSG",
    FILTER_CHARGE_TYPE: "FILTER_CHARGE_TYPE",
    DECEMBER_AT_MONTH_END: "DECEMBER_AT_MONTH_END",
    GENERAL_CHARGE_TYPE_FOR_COV: "GENERAL_CHARGE_TYPE_FOR_COV",
    CALCULATE_BY: "CALCULATE_BY",
    DOC_USER_PRINTER: "DOC_USER_PRINTER",
    DOC_USER_PRINTER_API: "DOC_USER_PRINTER_API",
    DUMMY_COMPANY: "DUMMY_COMPANY",
    REPORT_DAYS_LIMIT: "REPORT_DAYS_LIMIT",
    OUTPUT_VAT_REPORT: "OUTPUT_VAT_REPORT",
    COLL_INV_REC_COPIES: "COLL_INV_REC_COPIES",
    WAIVER_REVERSE_REASON_CODE: "WAIVER_REVERSE_REASON_CODE",
    BANK_ADVISE_SIGNATURE_COMPANY: "BANK_ADVISE_SIGNATURE_COMPANY",
    CFS_STF_UNSTF_CHG: "CFS_STF_UNSTF_CHG",
    IB_FULL: "IB-FULL",
    N_A: "N/A",
    UNSTF: "UNSTF",
    DG_OOG_TAR: "DG_OOG_TAR",
    STORAGE_CHARGE_FOR_ADDITIONAL: "STORAGE_CHARGE_FOR_ADDITIONAL",
    COUNTER_SUR_LIST_FOR_DG_OOG: "COUNTER_SUR_LIST_FOR_DG_OOG",
    MARSHALLING_LOCATION_TYPE: "MARSHALLING_LOCATION_TYPE",
    VAT_TAX_CODE: "VAT_TAX_CODE",
    CUST_INSP_SUB_CHARGE_TYPE_CODE: "CUST_INSP_SUB_CHARGE_TYPE",
    SURCHARGE_PERCENTAGE_DG: "SURCHARGE_PERCENTAGE_DG",
    STORAGE_SURCHARGE_PERCENTAGE: "STORAGE_SURCHARGE_PERCENTAGE"
})